<template>
  <div class="step-wrapper safe-area-top">
    <div class="number text-purple-gradient">{{ index + 1 }}</div>
    <div class="info" v-html="step.info"></div>
  </div>
</template>

<script>
export default {
  name: 'Step',
  props: {
    step: Object,
    index: Number,
    disabled: Boolean,
    hideButton: Boolean,
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('next');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.step-wrapper {
  @apply w-full flex items-center bg-white px-8;
  height: 18%;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
}
.number {
  font-size: 70px;
  line-height: 60px;
}
.info {
  @apply flex-1 mx-6 text-base font-semibold;
  line-height: 20px;
}
.next {
  @apply flex justify-center items-center ml-auto;
  width: 85px;
  height: 60px;
  background: linear-gradient(90deg, #540deb 11.03%, #2245ff 83.45%);
  box-shadow: 0 4px 20px rgba(121, 121, 121, 0.25);
  border-radius: 60px;
  &:before {
    content: '';
    display: inline-flex;
    width: 16px;
    height: 26px;
    background-image: url('../../../assets/MobileScan/next-arrow.svg');
  }
  &.disabled {
    opacity: 0.3;
  }
}
</style>
